import { useTranslation } from '@front10/utils';
import { lightFormat, parseISO } from 'date-fns';
import { useMemo } from 'react';

export function noop() {}

export function never() {
  return false;
}

export function count(arr: readonly number[]) {
  let sum = 0;
  arr.forEach((el) => (sum += el));
  return sum;
}

export interface SelectConfigurationOption {
  value: string;
  labelKey: string;
  url?: string;
  rules?: Array<{}>;
}

export interface SelectConfiguration {
  options: SelectConfigurationOption[];
  defaultValue: string;
}

export interface CheckboxConfiguration {
  defaultValue: boolean;
  name: string;
  labelKey: string;
}

export interface SelectProps {
  options: Array<{
    value: string;
    label: string;
    href?: string;
    rules?: Array<{}>;
  }>;
  defaultValue: string;
}

const defaultSelectConfig = { options: [], defaultValue: '' };

export function useSelectProps(
  config: SelectConfiguration = defaultSelectConfig,
  overrideDefault?: string
): SelectProps {
  const translate = useTranslation();
  return useMemo(
    () => ({
      defaultValue: overrideDefault ?? config.defaultValue,
      options: config.options.map((val) => ({
        value: val.value,
        label: translate(val.labelKey, val.labelKey),
        href: val.url,
        rules: val.rules
      }))
    }),
    [config.defaultValue, config.options, overrideDefault, translate]
  );
}

const defaultCheckboxConfig: CheckboxConfiguration[] = [];

export function useCheckboxProps(config: Array<CheckboxConfiguration> = defaultCheckboxConfig) {
  const translate = useTranslation();
  return useMemo(
    () =>
      config.map((val) => ({
        name: val.name,
        label: translate(val.labelKey, val.labelKey),
        defaultValue: val.defaultValue
      })),
    [config, translate]
  );
}

export function formatDate(date: Date, format: string) {
  try {
    return lightFormat(date, format);
  } catch {
    return date.toLocaleDateString();
  }
}

export function parseDate(date: string) {
  try {
    return parseISO(date);
  } catch {
    return new Date(NaN);
  }
}
